import React from 'react';
import ProductPicker from '@/component/dict/complex/product/Select.jsx';
import { Col, Modal, Row } from 'react-bootstrap';
import {
  FormControl,
  Button,
  Checkbox,
  Radio,
  DateTimePicker2 as DateTimePicker,
} from '../../../form/FormControls.jsx';
import FromToDatePickers from '../../../form/FromToDateHorizontalPickers';
import Label from '@/component/form/Label.jsx';
import Quantity from '../elements/Quantity.jsx';
import RefPicker from '../../../dict/simple/select/DictPicker.jsx';
import { FormTextField } from '../elements/FormTextField';
import { dateTimePickerFormat, getLoadingTermDerliveryTerms, usdDefaultCurrencyRates }
  from '../../../../util/util.jsx';
import { Audit } from '../audit/Audit.jsx';
import CurrencyInput from '@/component/form/currencyinput/index.jsx';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
moment.locale('en');
momentLocalizer();
import { alterProduct, alterProductField, alterProductFields,
  addDealExpenses, setDealExpenses, addDealPayment,
  updateShrinkageExpense } from '../store/deal.store.js';
import { connect } from 'react-redux';
import { handleFormChanged, setBulkExpensesConstructed } from '@/store/allaround.store.js';
import FancyInput from '@/component/form/numinput/index.jsx';
import AvailableSince, { VERSIONS } from '@/util/version';
import Expenses from '../expenses/Edit.jsx';
import { List, Map } from 'immutable';
import { divideBulkPaymentForLink, filterBulkPayments,
  getBulkPaymentFiles } from '../expenses/ExpensesUtils';
import _ from 'lodash';
import Select from 'react-select';
import { REF_PATH as EXPENSES_TYPE_REF_PATH }
  from '@/component/dict/complex/expensestype/Const';
import { REF_PATH as BUYER_REF_PATH }
  from '@/component/dict/simple/buyer/Const';
import { REF_PATH as DELIVERY_TERM_REF_PATH }
  from '@/component/dict/simple/deliveryterm/Const';
import { REF_PATH as PAYMENTMETHOD_REF_PATH }
  from '@/component/dict/simple/paymentmethod/Const';
import { storeFiles } from '../store/files.store';
import CreatePaymentModal from './CreatePaymentModal';
import { formatNumberZeroIfNull, formatCurrency } from './BaseElement';
import DealPaymentsDisplay from './DealPaymentsDisplay';
import RoleConfigFilter from '@/component/auth/RoleConfigFilter.jsx';
import { createSelector } from 'reselect';
import trash from '../../../../../style/trash.png';
import audit from '../../../../../style/audit.png';

export const SHRINKAGE_EXPENSE = 'Shrinkage';

/* eslint-disable */
const debounce = (func, time, field, component) => {
  let locked = false;
  let args = null;
  let val = null;
  return function () {
    args = [...arguments];
    val = args[0];
    component.setState({ fieldValues: {...component.state.fieldValues, [field]: val}});
    if (locked) {
      return;
    }
    locked = true;
    setTimeout(() => {
      func(val);
      locked = false;
      component.setState({ fieldValues: {...component.state.fieldValues, [field]: null}});
    }, time);
  };
};
/* eslint-enable */

const getFieldValue = (data, field, state) => {
  if (state[field] != undefined && state[field] != null) {
    return state[field];
  }
  return data.get(field);
};

export const paymentToString = (payment, paymentMethods) => {
  if (!payment || !payment.get) {
    return '';
  }
  const method = !paymentMethods ? '' : paymentMethods
    .find(ref => ref.get('id') == payment.get('paymentMethod'), this, new Map()).get('name', '');
  let amount = '';
  switch (payment.get('fullCostType')) {
    case 'PERCENT':
      amount = `${payment.get('fullCostPercent') || 0}%`;
      break;
    case 'BALANCE':
      amount = 'balance amount';
      break;
    case 'VALUE':
    default:
      amount = `${formatCurrency(
        payment.get('dueAmountCurrency'))}${formatNumberZeroIfNull(
        payment.get('dueAmount') || 0)}`;
      break;
  }
  let dateOffset = '';
  switch (payment.get('dueDateOffsetType')) {
    case 'BEFORE':
    case 'AFTER':
      dateOffset = !payment.get('dueDateOffsetValue') ? '' :
        ` ${payment.get('dueDateOffsetValue')} ${payment.get('dueDateOffsetValue') == 1 ?
          'day' : 'days'} ${payment.get('dueDateOffsetType').toLowerCase()}`;
      break;
    case 'BY':
    default:
      break;
  }
  let dateType = '';
  switch (payment.get('dueDateAnchorType')) {
    case 'CONTRACT':
      dateType = ' by contract date';
      break;
    case 'BLDATE':
      dateType = ' by BL date';
      break;
    case 'LAYCAN':
      dateType = ' by laycan date';
      break;
    case 'DATE':
    default: {
      const dueDate = payment.get('dueDate');
      dateType = dueDate ? ` latest by ${dueDate}` : '';
      break;
    }
  }
  const result = `${method} payment ${amount ? 'of ' : ''}${amount}${dateOffset}${dateType}.`;
  return result.charAt(0).toUpperCase() + result.slice(1);
};

class CompositeProductEditClass extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeCreatePaymentModal = this.closeCreatePaymentModal.bind(this);
    this.openCreatePaymentModal = this.openCreatePaymentModal.bind(this);
    this.yesButton = this.yesButton.bind(this);
    this.constructBulkExpenses = this.constructBulkExpenses.bind(this);
    this.updateQuantity = this.updateQuantity.bind(this);
    this.updateFixedPrice = _.debounce(this.onPriceValueChange.bind(this), 150);
    this.updateProductStore = this.updateProductStore.bind(this);
    this.updateProductStoreWithProductType = this.updateProductStoreWithProductType.bind(this);
    this.onChangePriceCurrency = _.debounce(this.onChangePriceCurrency.bind(this), 150);
    this.loadingTerms = this.loadingTerms.bind(this);
    this.constructPaymentsText = this.constructPaymentsText.bind(this);
    this.constructCustomContractPayments = this.constructCustomContractPayments.bind(this);
    this.hasLCPayment = this.hasLCPayment.bind(this);

    const common = {
      showModal: false,
      showCreatePaymentModal: false,
    };
    if (props.data) {
      // eslint-disable-next-line
      this.state = {
        init: true,
        ...common,
        productChangeDisabled: this.isProductChangeDisabled(props),
        fixedPrice: props.data.get('fixedPrice') === null
          ? true
          : props.data.get('fixedPrice', true),
        customPayments: this.constructCustomContractPayments(props),
      };
    } else {
      this.state = {
        init: false,
        ...common,
        productChangeDisabled: false,
        fixedPrice: true,
      };
    }
    this.state.fieldValues = {};
    this.updatePayment = debounce(this.updateProductStore.bind(this, 'payment'),
      500, 'payment', this);
    this.updateCustomPaymentText = debounce(this.updateProductStore.bind(this, 'customPaymentText'),
      150, 'customPaymentText', this);
    this.updateSpecification = debounce(this.updateProductStore.bind(this, 'specification'),
      100, 'specification', this);
    this.updateLcReference = debounce(this.updateProductStore.bind(this, 'lcReference'),
      100, 'lcReference', this);
    this.updateFormula = debounce(this.updateProductStore.bind(this, 'priceFormula'),
      150, 'priceFormula', this);
  }

  componentWillMount() {
    this.constructBulkExpenses(this.props);
  }

  componentDidMount() {
    // eslint-disable-next-line
    this.setState({ fieldValues: {} });
  }

  componentWillReceiveProps(props) {
    this.constructBulkExpenses(props, this.props);
    if (props.data && !this.state.init) {
      // eslint-disable-next-line
      this.setState({
        id: props.data.get('id'),
        init: true,
        fixedPrice: props.data.get('fixedPrice') === null
          ? true
          : props.data.get('fixedPrice', true),
      });
    }
    if (props.links) {
      const productChangeDisabled = this.isProductChangeDisabled(props);
      if (productChangeDisabled != this.state.productChangeDisabled) {
        this.setState({ productChangeDisabled });
      }
    }
    this.setState({ hasLCPayment: this.hasLCPayment(props) });
    const customPayments = this.constructCustomContractPayments(props);
    const paymentFixedText = this.constructPaymentsText(props, customPayments);
    if (paymentFixedText != this.state.paymentFixedText) {
      this.setState({ paymentFixedText, customPayments });
    }
  }

  shouldComponentUpdate(props, state) {
    if ((props.data && this.props.data &&
        (props.data.get('purchaseLink') != this.props.data.get('purchaseLink')
        || props.data.get('saleLink') != this.props.data.get('saleLink')))
        || state != this.state || (!this.props.data && props.data)
        || this.props.data != props.data
        || this.props.currencyRates != props.currencyRates) {
      return true;
    }
    return false;
  }
  onChangePriceCurrency(val) {
    if (val) {
      const newPayments = this.props.data.get('payments', new List()).map((p) => {
        if (p.get('isCustomContractPayment') &&
        (p.get('fullCostType') == 'BALANCE' || p.get('fullCostType') == 'PERCENT')) {
          return p.set('dueAmountCurrency', val.currency);
        }
        return p;
      });
      this.updateProductStoreWithMap(
        new Map({ priceCurrency: val.currency,
          priceCurrencyRates: val.rates,
          payments: newPayments }));
      const newProduct = this.props.data
        .set('priceCurrency', val.currency)
        .set('priceCurrencyRates', val.rates)
        .set('payments', newPayments);
      this.props.updateShrinkageExpense(newProduct, this.props.shrinkageExpense);
    }
  }

  onPriceValueChange(ev, val) {
    this.updateProductStore('priceValue', val);
    const newProduct = this.props.data
      .set('priceValue', val);
    this.props.updateShrinkageExpense(newProduct, this.props.shrinkageExpense);
  }

  onPriceRadioChange(bool) {
    this.setState({ fixedPrice: bool });
    this.updateProductStore('fixedPrice', bool);
    const newProduct = this.props.data
      .set('fixedPrice', bool);
    this.props.updateShrinkageExpense(newProduct, this.props.shrinkageExpense);
  }

  isProductChangeDisabled(props) {
    if (props.links) {
      const otherDealType = props.owner == 'purchase' ? 'sale' : 'purchase';

      const link = props.links.find(l => !l.get('hidden')
        && (l.get(`${otherDealType}Product`)
        || l.get(`${otherDealType}Product`) === 0
        || l.get('transport') || l.get('transport') === 0));

      if (link) {
        return true;
      }
    }
    return false;
  }

  constructBulkExpenses(props = this.props, oldProps) {
    if (props.links && props.transports && props.expensestypes &&
    (this.props.expensesRebuilded || !oldProps || oldProps.links != props.links ||
     props.transports != this.props.transports ||
     props.expensestypes != this.props.expensestypes ||
    (props.data && oldProps.data && oldProps.data.get('payments') != props.data.get('payments')))) {
      let files = new List();
      const uniqUUIDs = [];
      let allDocuments = new List();
      // reset expensesToPreBulkState
      let currentExpenses = props.data.get('expenses', new List());
      currentExpenses = currentExpenses.map(e => e.delete('actualWithBulk')
        .delete('isBulkExpenseWithoutBL')
        .set('bulkExpense', false));
      props.links.forEach((l) => {
        const transportId = l.get('transport');
        if (transportId != undefined && transportId != null && props.transports) {
          const transport = props.transports
            .find(t => t.get('id') == transportId, this, new Map());

          const bulkPayments = filterBulkPayments(transport.get('bulkPayments', new List()),
            props.dealType, props.expensestypes, transportId);
          allDocuments = allDocuments.merge(bulkPayments.map(p => p.get('document')));
          let bulkExpenses = divideBulkPaymentForLink(bulkPayments, l,
            props.transports);
          let mergedExpenseTypeIds = new Set();
          currentExpenses = currentExpenses.map((e) => {
            const bulkExpenseIdx = bulkExpenses.findIndex(be =>
              be.get('expensesType') == e.get('expensesType'));
            let newE = e;
            if (bulkExpenseIdx > -1) {
              const bulkExpense = bulkExpenses.get(bulkExpenseIdx);
              if (bulkExpense.get('isBulkExpenseWithoutBL')) {
                newE = e.set('summType', 'LS')
                  .set('bulkExpense', true)
                  .set('isBulkExpenseWithoutBL', true);
              } else {
                newE = e.set('summType', 'LS')
                  .set('bulkExpense', true)
                  .set('actualWithBulk', e.get('actualWithBulk', e.get('actual', 0))
                  + (e.get('isDebit') == bulkExpense.get('isDebit') ?
                    bulkExpense.get('actual') : -bulkExpense.get('actual')));
              }
              mergedExpenseTypeIds = mergedExpenseTypeIds.add(e.get('expensesType'));
            }
            return newE;
          });
          bulkExpenses = bulkExpenses.filter(
            be => !mergedExpenseTypeIds.has(be.get('expensesType')));
          currentExpenses = currentExpenses.concat(
            bulkExpenses.map(be => be
              .set('actualWithBulk', be.get('actual', 0))
              .set('actual', 0)
              .set('bulkExpense', true)));
          currentExpenses = currentExpenses.map((e) => {
            if (e.get('isBulkExpenseWithoutBL')) {
              return e.set('actualWithBulk', -1);
            }
            if (e.get('actualWithBulk') < 0) {
              return e.set('isDebit', !e.get('isDebit'))
                .set('actualWithBulk', Math.abs(e.get('actualWithBulk')));
            }
            return e;
          });
        }
      });
      this.props.setExpenses(currentExpenses);
      files = getBulkPaymentFiles(allDocuments, files, uniqUUIDs);
      if (files.size > 0 && !this.bulkExpenseFilesAdded) {
        this.bulkExpenseFilesAdded = true;
        this.props.storeFiles(files.toJS(), 'USUAL');
      }
      this.props.setBulkExpensesConstructed();
    }
  }

  hasLCPayment(props = this.props) {
    const getMethodName = (payment) => props.paymentMethods
      .find(ref => ref.get('id') == payment.get('paymentMethod'), this, new Map()).get('name', '');

    if (props && props.data) {
      return props.data.get('payments', new List())
        .filter(p => p.get('paymentMethod'))
        .map(p => getMethodName(p))
        .filter(method => method.indexOf('LC') > -1).size > 0;
    }
    return false;
  }

  constructCustomContractPayments(props = this.props) {
    let result = '';
    if (props && props.data) {
      result = props.data.get('payments', new List())
        .map((p, idx) => p.set('paymentIdx', idx))
        .filter(p => p.get('fullCostType'))
        .reverse();
    }
    return result;
  }
  constructPaymentsText(props = this.props, payments = new List()) {
    const result = payments
      .map((p, idx) => `${idx + 1}. ${paymentToString(p, props.paymentMethods)}`)
      .join('\n');
    const concatResult = `${result || ''} ${props &&
        props.data && props.data.get('customPaymentText') ?
      `\n${props.data.get('customPaymentText') || ''}` : ''}`;
    this.updatePayment(concatResult.trim());
    return result;
  }

  openModal() {
    this.setState({ showModal: true });
  }
  closeModal() {
    this.setState({ showModal: false });
  }
  yesButton() {
    this.setState({ showModal: false });
    this.props.alterProductField('hidden', true);
    this.props.onDelete();
    this.props.handleFormChanged();
  }


  updateProductStore(field, value) {
    this.props.alterProductField(field, value);
  }

  updateProductStoreWithMap(map) {
    this.props.alterProductFields(map);
  }

  updateProductStoreWithProductType(value) {
    this.props.alterProduct(
      this.props.data
        .set('product', value !== undefined && value !== null ? value.product : value)
        .set('productType', value !== undefined && value !== null ? value.value : value),
    );
  }

  updateQuantity(quantityObject) {
    this.updateProductStoreWithMap(
      new Map({ quantity: quantityObject.quantity,
        quantityMin: quantityObject.quantityMin,
        quantityMinP: quantityObject.quantityMinP,
        quantityMax: quantityObject.quantityMax,
        quantityMaxP: quantityObject.quantityMaxP,
        contractOption: quantityObject.contractOption,
        completedLink: quantityObject.completedLink,
        shrinkage: quantityObject.shrinkage,
        shrinkageIsPercentage: quantityObject.shrinkageIsPercentage,
        shrinkagePercent: quantityObject.shrinkagePercent }));
    const newProduct = this.props.data.merge(
      _.pick(quantityObject,
        ['quantity', 'quantityMin', 'quantityMinP', 'quantityMaxP', 'quantityMax',
          'contractOption', 'completedLink',
          'shrinkage', 'shrinkageIsPercentage', 'shrinkagePercent']),
    );
    this.props.updateShrinkageExpense(newProduct, this.props.shrinkageExpense);
  }

  loadingTerms() {
    return (
      <div>
        <Col md={6}>
          <Label
            label="Loading/Discharge terms"
            vertical
            sm={12}
            style={{ padding: '0px 7px 0px 0px' }}
          >
            <Button
              onClick={() => {
                this.updateProductStore('dispatchType', 'RATE');
              }}
              bsStyle={this.props.data.get('dispatchType') == 'CQD' ? 'default' : 'primary'}
              style={{ width: '50% ', height: '36px' }}
              disabled={this.props.disabled}
              className={'button-pair-left'}
              id="portRate"
            >
              Rate
            </Button>
            <Button
              onClick={() => {
                this.updateProductStore('dispatchType', 'CQD');
              }}
              bsStyle={this.props.data.get('dispatchType') == 'CQD' ? 'primary' : 'default'}
              style={{ width: '50% ', height: '36px' }}
              disabled={this.props.disabled}
              className={'button-pair-right'}
              id="portCQD"
            >
              CQD
            </Button>
          </Label>
        </Col>
        {this.props.data.get('dispatchType') != 'CQD' ?
          <Col md={6}>
            <Label label="&nbsp;" vertical sm={12} style={{ padding: '0px 14px 0px 14px' }}>
              <Row>
                <Col sm={3} style={{ padding: '0px 5px 0px 5px' }}>
                  <FancyInput
                    className="form-control"
                    thousand
                    fraction={0}
                    positive
                    negative={false}
                    type="number"
                    id="rate" name="rate"
                    onChange={(ev, val) => this.updateProductStore('rate', val)}
                    value={this.props.data.get('rate') || ''}
                    disabled={this.props.disabled}
                  />
                </Col>
                <Col sm={5} style={{ padding: '0px 5px 0px 5px' }}>
                  <RefPicker
                    dict="loadingterm" name="term"
                    onChangeFunc={val =>
                      this.updateProductStore('term',
                        val !== undefined && val !== null ? val.value : val)}
                    defaultValue={this.props.data.get('term')}
                    disabled={this.props.disabled}
                  />
                </Col>
                <Col sm={4} style={{ padding: '0px 5px 0px 5px' }}>
                  <FormControl
                    componentClass="select"
                    placeholder=""
                    name="termModificator"
                    onChange={ev => this.updateProductStore('termModificator', ev.target.value)}
                    defaultValue={this.props.data.get('termModificator')}
                    disabled={this.props.disabled}
                  >
                    <option value="UU">UU</option>
                    <option value="EIU">EIU</option>
                  </FormControl>
                </Col>
              </Row>
            </Label>
          </Col>
          :
          <Col md={6}>
            <Label label="Detention" vertical sm={12} style={{ padding: '0px 5px 0px 5px' }}>
              <Row id="detentionCurrency">
                <Col sm={4}>
                  <CurrencyInput
                    noRates
                    name="detentionCurrency"
                    defaultValue={this.props.data.get('detentionCurrency')}
                    disabled={this.props.disabled}
                    onChange={val => this.updateProductStore('detentionCurrency', val)}
                  />
                </Col>
                <Col sm={8}>
                  <FancyInput
                    className="form-control"
                    thousand
                    fraction={0}
                    positive
                    negative={false}
                    type="number"
                    id="detentionAmount" name="detentionAmount"
                    onChange={(ev, val) => this.updateProductStore('detentionAmount', val)}
                    value={this.props.data.get('detentionAmount') || ''}
                    disabled={this.props.disabled}
                  />
                </Col>
              </Row>
            </Label>
          </Col>
        }
        {this.props.data.get('dispatchType') != 'CQD' ?
          <Row>
            <Col md={6}>
              <Label
                label="Demurrage"
                vertical sm={12}
                style={{ paddingLeft: '15px', paddingRight: '5px' }}
              >
                <Row id="demurrageCurrency">
                  <Col sm={4} style={{ paddingRight: '0px' }}>
                    <CurrencyInput
                      noRates
                      name="demurrageCurrency"
                      defaultValue={this.props.data.get('demurrageCurrency')}
                      disabled={this.props.disabled}
                      onChange={val => this.updateProductStore('demurrageCurrency', val)}
                    />
                  </Col>
                  <Col sm={8}>
                    <FancyInput
                      className="form-control"
                      thousand
                      fraction={0}
                      positive
                      negative={false}
                      type="number"
                      id="demurrageAmount" name="demurrageAmount"
                      onChange={(ev, val) => this.updateProductStore('demurrageAmount', val)}
                      value={this.props.data.get('demurrageAmount') || ''}
                      disabled={this.props.disabled}
                    />
                  </Col>
                </Row>
              </Label>
            </Col>
            <Col md={6}>
              <Label
                label="Dispatch"
                vertical sm={12}
                style={{ paddingLeft: '5px', paddingRight: '17px' }}
              >
                <Row id="dispatchCurrency">
                  <Col sm={4} style={{ paddingRight: '0px' }}>
                    <CurrencyInput
                      noRates
                      name="dispatchCurrency"
                      defaultValue={this.props.data.get('dispatchCurrency')}
                      disabled={this.props.disabled}
                      onChange={val => this.updateProductStore('dispatchCurrency', val)}
                    />
                  </Col>
                  <Col sm={8} style={{ paddingRight: '13px' }}>
                    <FancyInput
                      className="form-control"
                      thousand
                      fraction={0}
                      positive
                      negative={false}
                      type="number"
                      id="dispatchAmount" name="dispatchAmount"
                      onChange={(ev, val) => this.updateProductStore('dispatchAmount', val)}
                      value={this.props.data.get('dispatchAmount') || ''}
                      disabled={this.props.disabled}
                    />
                  </Col>
                </Row>
              </Label>
            </Col>
          </Row>
          :
          <Row style={{ height: '69px' }} />
        }
      </div>
    );
  }

  closeCreatePaymentModal() {
    this.setState({ showCreatePaymentModal: false });
  }

  openCreatePaymentModal() {
    this.setState({ showCreatePaymentModal: true });
  }

  render() {
    const defaultHidden = this.props.defaultValue ? this.props.defaultValue.get('hidden') : false;
    const buyerId = this.props.deal.get('buyer');

    const dt = this.props.deliveryTerms.find(d =>
      d.get('id') == this.props.data.get('deliveryTerm'), this, new Map());
    const buyer = buyerId && this.props.buyers.find(b => b.get('id') === buyerId, this, new Map());
    const showCarInsurance = this.props.dealType === 'sale'
      && ((buyer && buyer.get('carInsurance')) || dt.get('name') === 'CIF');
    let quantityAlert;
    switch (this.props.data.get('transportType')) {
      case 'CONTAINER':
      case 'RAILCAR':
      case 'TRUCK':
        quantityAlert = 10000;
        break;
      case 'BULK':
      default:
        quantityAlert = 100000;
    }
    return (<div style={{ display: defaultHidden ? 'none' : '' }}>
      <CreatePaymentModal
        contractDate={this.props.deal.get(`${this.props.dealType}Date`)}
        dealType={this.props.dealType}
        idx={this.props.idx}
        product={this.props.data}
        closeModal={this.closeCreatePaymentModal}
        show={this.state.showCreatePaymentModal}
        contractor={this.props.contractor}
      />
      <Modal bsSize="small" show={this.state.showModal} onHide={this.closeModal} >
        <Modal.Body>
          Are you sure you want to {this.state.hidden ? 'restore' : 'delete'} atom?
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={this.yesButton}>Yes</Button>
          <Button onClick={this.closeModal}>No</Button>
        </Modal.Footer>
      </Modal>
      <div name="product" style={{ border: 'none', boxShadow: 'none' }}>
        <fieldset id={`productFieldSet${this.props.formId}`}>
          <Label vertical label="Product">
            <ProductPicker
              name="productType"
              onChangeFunc={val =>
                this.updateProductStoreWithProductType(val)}
              defaultValue={this.props.data.get('productType')}
              disabled={this.props.disabled || this.state.productChangeDisabled}
            />
          </Label>
          <Label vertical label="Packing">
            <RefPicker
              dict="packing" name="packing"
              onChangeFunc={val =>
                this.updateProductStore('packing',
                  val !== undefined && val !== null ? val.value : val)}
              defaultValue={this.props.data.get('packing')}
              disabled={this.props.disabled}
            />
          </Label>
          <div className={'product-quantity-separator'} />
          <Quantity
            vertical
            updateOnNewProps
            data={this.props.data}
            onChangeFunc={this.updateQuantity}
            showContractOption
            links={this.props.links}
            showUnlinked
            showShrinkage
            dealType={this.props.dealType}
            disabled={this.props.disabled}
            alertOnQuantityGtThan={quantityAlert}
          />
          <div className={'product-quantity-separator'} style={{ marginTop: 10 }} />
          <Label vertical label="Price">
            <Row>
              <Col md={4}>
                <Radio
                  id="priceFixed" name={`fixedPriceRadio${this.props.formId}`} inline
                  checked={this.state.fixedPrice}
                  onChange={() => this.onPriceRadioChange(true)}
                  disabled={this.props.disabled}
                >
                  fix
                </Radio>
                <Radio
                  id="priceFormula" name={`fixedPriceRadio${this.props.formId}`} inline
                  checked={!this.state.fixedPrice}
                  onChange={() => this.onPriceRadioChange(false)}
                  disabled={this.props.disabled}
                >
                  formula
                </Radio>
                <Checkbox
                  name="fixedPrice" checked={this.state.fixedPrice} onChange={() => {}}
                  style={{ display: 'none' }}
                  disabled={this.props.disabled}
                />
              </Col>
              <Col md={8}>
                <Row id="priceFixed" style={{ display: this.state.fixedPrice ? '' : 'none' }}>
                  <Col xs={3}>
                    <CurrencyInput
                      name="priceCurrency"
                      defaultValue={this.props.data.get('priceCurrency')}
                      defaultValueRates={usdDefaultCurrencyRates(
                        this.props.data.get('priceCurrencyRates'))}
                      disabled={this.props.disabled}
                      onChange={this.onChangePriceCurrency}
                    />
                  </Col>
                  <Col xs={9}>
                    <FancyInput
                      className="form-control"
                      thousand
                      fraction={2}
                      positive
                      negative={false}
                      type="number"
                      id="priceValue" name="priceValue"
                      value={this.props.data.get('priceValue') === undefined
                        ? '' : this.props.data.get('priceValue')}
                      onChange={this.updateFixedPrice}
                      disabled={this.props.disabled}
                    />
                  </Col>
                </Row>
                <Row id="priceFormula" style={{ display: this.state.fixedPrice ? 'none' : '' }}>
                  <Col sm={12}>
                    <FormTextField
                      name="priceFormula"
                      onChangeFunc={this.updateFormula}
                      defaultValue={
                        getFieldValue(this.props.data, 'priceFormula', this.state.fieldValues)}
                      disabled={this.props.disabled}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Label>
          <Label vertical label="Transport type">
            <Select
              id="transportType"
              name="transportType"
              value={this.props.data.get('transportType')}
              onChange={option => this.updateProductStore('transportType', option && option.value)}
              options={[
                { value: 'BULK', label: 'Bulk Vessel' },
                { value: 'CONTAINER', label: 'Container' },
                { value: 'RAILCAR', label: 'Railcar' },
                { value: 'TRUCK', label: 'Truck' },
              ]}
              disabled={this.props.disabled}
            />
          </Label>
          <Label vertical label="Delivery term">
            <RefPicker
              dict="deliveryterm"
              name="deliveryTerm"
              onChangeFunc={(val) => {
                this.updateProductStore('deliveryTerm',
                  val !== undefined && val !== null ? val.value : val);
              }}
              defaultValue={this.props.data.get('deliveryTerm')}
              disabled={this.props.disabled}
            />
          </Label>
          <Label vertical label="Port">
            <RefPicker
              dict="port"
              name="ports"
              onChangeFunc={val => this.updateProductStore('ports', val.map(port => port.value))}
              defaultValue={this.props.data.get('ports')}
              multi
              disabled={this.props.disabled}
            />
          </Label>
          <Label vertical label="Shipment">
            <FromToDatePickers
              bindSelect
              label="Shipment"
              labelFrom="from"
              labelTo="to"
              nameFrom="shipmentFrom"
              nameTo="shipmentTo"
              onChangeFrom={(val) => {
                this.updateProductStore('shipmentFrom',
                  val ? moment(val).format('DD MMM YYYY') : undefined);
                this.props.handleFormChanged();
              }}
              onChangeTo={(val) => {
                this.updateProductStore('shipmentTo',
                  val ? moment(val).format('DD MMM YYYY') : undefined);
                this.props.handleFormChanged();
              }}
              defaultValueFrom={this.props.data.get('shipmentFrom')
                ? new Date(this.props.data.get('shipmentFrom'))
                : undefined}
              defaultValueTo={this.props.data.get('shipmentTo')
                ? new Date(this.props.data.get('shipmentTo'))
                : undefined}
              disabled={this.props.disabled}
            />
          </Label>
          {showCarInsurance &&
            <Label vertical label="Cargo insurance">
              <Checkbox
                name="carInsurance" checked={this.props.data.get('carInsurance')}
                onChange={(e) => {
                  this.updateProductStore('carInsurance', e.target.checked);
                  this.props.handleFormChanged();
                }}
                disabled={this.props.disabled}
              />
            </Label>
          }
          <Label vertical label="Payment" childStyle={{ display: 'flex' }}>
            <div className="product-payments">
              <DealPaymentsDisplay
                contractDate={this.props.deal.get(`${this.props.dealType}Date`)}
                dealType={this.props.dealType}
                productIdx={this.props.idx}
                product={this.props.data}
                customPayments={this.state.customPayments}
                paymentMethods={this.props.paymentMethods}
                contractor={this.props.contractor}
              />
              <FormTextField
                className="custom-payment-text"
                name="customPaymentText"
                onChangeFunc={this.updateCustomPaymentText}
                defaultValue={getFieldValue(this.props.data,
                  'customPaymentText', this.state.fieldValues)}
                disabled={this.props.disabled}
              />
            </div>
            <Button
              bsStyle="primary"
              style={{ marginLeft: 5 }}
              onClick={this.openCreatePaymentModal}
              disabled={this.props.disabled || (this.props.links &&
                 this.props.links.filter(l => !l.get('hidden')).size)}
            >
              Add
            </Button>
          </Label>
          <Row>
            <Col
              md={this.props.data.get('latestPaymentDate') ? 6 : 12}
              style={{ display: this.state.hasLCPayment ||
                 this.props.data.get('lcReference') ? 'block' : 'none' }}
            >
              <Label
                vertical label="LC Reference"
                sm={this.props.data.get('latestPaymentDate') ? 6 : 3}
              >
                <FormTextField
                  name="lcReference"
                  rows={1}
                  onChangeFunc={this.updateLcReference}
                  defaultValue={
                    getFieldValue(this.props.data, 'lcReference', this.state.fieldValues)}
                  disabled={this.props.disabled}
                />
              </Label>
            </Col>
            <Col
              md={6}
              style={{ display: this.props.data.get('latestPaymentDate') ? 'block' : 'none' }}
            >
              <Label vertical label="LC Opening Deadline" sm={6}>
                <DateTimePicker
                  format={dateTimePickerFormat}
                  time={false}
                  name="latestPaymentDate"
                  onChange={(val) => {
                    this.updateProductStore('latestPaymentDate',
                      val ? moment(val).format('DD MMM YYYY') : undefined);
                    this.props.handleFormChanged();
                  }}
                  defaultValue={this.props.data.get('latestPaymentDate')
                    ? new Date(this.props.data.get('latestPaymentDate'))
                    : undefined}
                  disabled={this.props.disabled}
                />
              </Label>
            </Col>
          </Row>
          {getLoadingTermDerliveryTerms().contains(this.props.deliveryTerms
            .find(d => d.get('id') == this.props.data.get('deliveryTerm'),
              this, new Map()).get('name')) ?
            this.loadingTerms()
            :
            <div />
          }
          <Label vertical label="Remarks">
            <FormTextField
              name="specification"
              onChangeFunc={this.updateSpecification}
              defaultValue={getFieldValue(this.props.data, 'specification', this.state.fieldValues)}
              disabled={this.props.disabled}
            />
          </Label>
          <div className="productHiddenControl">
            <FormControl
              id={`${this.props.formId}_product_id`} name="id" disabled
              value={this.props.data.get('id') ? this.props.data.get('id') : ''}
              style={{ display: 'none' }} onChange={() => ({})}
            />
          </div>
        </fieldset>
      </div>
      <AvailableSince version={VERSIONS.Harmony}>
        <Expenses
          key={`expenses-${this.props.idx}`}
          idx={this.props.idx}
          prefix={`product-${this.props.idx}`}
          dealType={this.props.dealType}
          disabled={this.props.disabled}
        />
      </AvailableSince>
      <Row className={'product-edit-footer'}>
        {!this.props.disabled ?
          <Button
            bsStyle="link"
            style={{ float: 'left' }}
            onClick={this.openModal}
          >
            <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
          </Button>
          : ''
        }
        {(this.props.data.get('id') || this.props.data.get('id') === 0) &&
          <AvailableSince version={VERSIONS.VasyaFinal}>
            <RoleConfigFilter permissions={['audit']}>
              <Audit
                group={{
                  deal: {
                    entity: this.props.deal,
                    module: this.props.dealType,
                  },
                  allProducts: {
                    entities: this.props.deal.get('products', new List()),
                    module: 'compositeproduct',
                  },
                }}
                selectedEntityString={`compositeproduct#${this.props.data.get('id')}`}
                title="Deal audit"
                buttonStyle={{ float: 'left' }}
              >
                <img src={audit} className={'audit-icon'} alt={'Audit'} />
              </Audit>
            </RoleConfigFilter>
          </AvailableSince>
        }
      </Row>
    </div>
    );
  }
}
CompositeProductEditClass.propTypes = {
  idx: React.PropTypes.number,
  currentUser: React.PropTypes.number,
  productsSelected: React.PropTypes.array,
  links: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.array]),
  defaultValue: React.PropTypes.object,
  label: React.PropTypes.string,
  data: React.PropTypes.object,
  deal: React.PropTypes.object,
  formId: React.PropTypes.number,
  owner: React.PropTypes.string,
  dealType: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  alterProduct: React.PropTypes.func,
  alterProductField: React.PropTypes.func,
  alterProductFields: React.PropTypes.func,
  handleFormChanged: React.PropTypes.func,
  onDelete: React.PropTypes.func,
  transports: React.PropTypes.object,
  addExpenses: React.PropTypes.func,
  expensestypes: React.PropTypes.object,
  storeFiles: React.PropTypes.func,
  expensesRebuilded: React.PropTypes.bool,
  setBulkExpensesConstructed: React.PropTypes.func,
  setExpenses: React.PropTypes.func,
  currencyRates: React.PropTypes.object,
  deliveryTerms: React.PropTypes.object,
  buyers: React.PropTypes.object,
  addDealPayment: React.PropTypes.func,
  paymentMethods: React.PropTypes.object,
  contractor: React.PropTypes.number,
  shrinkageExpense: React.PropTypes.object,
  updateShrinkageExpense: React.PropTypes.func,
};
const getExpensesTypes = state =>
  state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List());
const getShrinkageExpense = createSelector([getExpensesTypes],
  expenses => expenses.find(e => e.get('name') == SHRINKAGE_EXPENSE));
export default connect((state, props) => ({
  currentUser: Number(state.getIn(['session', 'id'])),
  transports: state.getIn(['data', 'deals', 'list', 'transport']),
  expensesRebuilded: state.getIn(['allaround', 'expensesRebuilded',
    props.data && props.data.get ? props.data.get('id') : props.idx], false),
  expensestypes: state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List()),
  buyers: state.getIn(['references', 'simple', BUYER_REF_PATH], new List()),
  deliveryTerms: state.getIn(['references', 'simple', DELIVERY_TERM_REF_PATH], new List()),
  currencyRates: state.getIn(['data', 'currencies']),
  paymentMethods: state.getIn(['references', 'simple', PAYMENTMETHOD_REF_PATH], new List()),
  shrinkageExpense: getShrinkageExpense(state),
}), (dispatch, props) => ({
  alterProduct(data) {
    alterProduct(dispatch, props.formId, data);
  },
  alterProductField(field, value) {
    alterProductField(dispatch, props.formId, field, value);
  },
  alterProductFields(map = new Map()) {
    alterProductFields(dispatch, props.formId, map);
  },
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
  addExpenses(expenses) {
    addDealExpenses(dispatch, props.idx, expenses);
  },
  setExpenses(expenses) {
    setDealExpenses(dispatch, props.idx, expenses);
  },
  storeFiles(files, type) {
    storeFiles(dispatch, files, type);
  },
  setBulkExpensesConstructed() {
    setBulkExpensesConstructed(dispatch,
      props.data && props.data.get ? props.data.get('id') : props.idx);
  },
  addDealPayment(payment) {
    addDealPayment(dispatch, props.idx, [], payment, true);
  },
  updateShrinkageExpense(product, shrinkageExpense) {
    updateShrinkageExpense(dispatch, product, props.idx, shrinkageExpense);
  },
}))(CompositeProductEditClass);
